import {
  AttractivenessTier,
  LocationTier,
  SalaryTier,
  SeniorityTier,
} from '~/lib/app/pricingCalculator'

export default {
  locationTier: {
    [LocationTier.FullyRemote]: 'Fully remote',
    [LocationTier.Tier1Remote]: 'Tier 1 (Berlin, MuC, Köln/ DD, HH) 3+ remote',
    [LocationTier.Tier1Hybrid]: 'Tier 1 (Berlin, MuC, Köln/ DD, HH) 1-3 remote',
    [LocationTier.Tier1Onsite]: 'Tier 1 (Berlin, MuC, Köln/ DD, HH) full office',
    [LocationTier.Tier2Remote]: 'Tier 2 (Stuttgart, FFM) 3+ remote',
    [LocationTier.Tier2Hybrid]: 'Tier 2 (Stuttgart, FFM) 1-3 remote',
    [LocationTier.Tier2Onsite]: 'Tier 2 (Stuttgart, FFM) full office',
    [LocationTier.Tier3Remote]: 'Tier 3 (Other)  1-3 remote',
    [LocationTier.Tier3Hybrid]: 'Tier 3 (Other) 3+ remote',
    [LocationTier.Tier3Onsite]: 'Tier 3 (Other) full office',
  },
  'test.idk.something': 'hello',
  seniorityTier: {
    [SeniorityTier.CareerChange]: 'Career change',
    [SeniorityTier.SdrBdr]: 'SDR/ BDR',
    [SeniorityTier.MidLevel]: 'Mid-level',
    [SeniorityTier.SeniorIc]: 'Senior IC',
    [SeniorityTier.SeniorTeamLead]: 'Senior Team-Lead',
  },
  attractivenessTier: {
    [AttractivenessTier.Low]: 'Low',
    [AttractivenessTier.Medium]: 'Medium',
    [AttractivenessTier.High]: 'High',
  },
  salaryTier: {
    [SalaryTier.Low]: 'Low',
    [SalaryTier.Medium]: 'Medium',
    [SalaryTier.High]: 'High',
  },
  outputFields: {
    createdApplications: {
      label: {
        short: 'Bewerbungen',
        long: 'Generierte Bewerbungen',
      },
    },
    matchingApplications: {
      label: {
        short: 'Übermittelte Bewerbungen',
        long: 'An Sie geschickte Bewerbungen',
      },
    },
    acceptedApplications: {
      label: {
        short: 'Davon passende',
        long: 'Davon passende',
      },
    },
    requiredDays: {
      label: {
        short: 'Monate',
        long: 'Erwartete Time-to-Hire Monate',
      },
    },
    hiresPerMonth: {
      label: {
        short: 'Stellt ein',
        long: 'Einstellungen/ Monat',
      },
    },
    budgetPerHire: {
      label: {
        short: '/ Bewerbung',
        long: 'Preis/ akzeptierter Bewerbung',
      },
    },
    budgetTotal: {
      label: {
        short: 'im Zimmer',
        long: 'Gesamtbudget',
      },
    },
    budgetMonthly: {
      label: {
        long: 'Monatsbudget',
      },
    },
  },
}
